export enum CupsAndLidsType {
    Standard = 0,
    StandardEcoCompostable = 1,
    Reserve = 2,
    ReserveEcoCompostable = 3
  }